import {EnvConfig} from "@/config/app.config"

export const envConfig: EnvConfig = {
    OIDC_AUTHORITY: "https://login.microsoftonline.com/4c867488-2d0b-43ff-9829-1aa2d7ae43b5/v2.0",
    OIDC_CLIENT_ID: "95902870-2ba5-4c03-96d0-f4320f7df883",
    OIDC_SCOPES: "openid profile api://95902870-2ba5-4c03-96d0-f4320f7df883/stores",
    TARGET_ENVIRONMENT: "DEV",
    API: {
        SPCI_BASE_URL: "https://us-central1-coop-selfcheckout.cloudfunctions.net/v1/spci/",
    },
    TRACKING: {
        LOG_ROCKET_APP_ID: "bs42ff/coop-selfcheckout-demo",
    },
}
